import React from 'react';
import { Field, getIn } from 'formik';
import { normalizeNumberByStep } from 'helpers/number';
import { Input as InputField } from '../../form';

const Input = ({
  type,
  placeholder,
  onChange,
  onKeyDown,
  onBeforeInput,
  onPaste,
  readOnly,
  resetValue,
  label,
  min,
  max,
  onMin = () => {},
  onMax = () => {},
  step = 1,
  onRemove,
  disabled,
  ...rest
}) => (
  <Field {...rest}>
    {({ field, form }) => {
      const props = {};
      const error = getIn(form.errors, field.name);
      const touch = getIn(form.touched, field.name);

      const onReset = () => {
        const initialValue = getIn(form.initialValues, field.name);
        form.setFieldTouched(field.name, false);
        form.setFieldValue(field.name, resetValue || initialValue || (type === 'number' ? 0 : ''));
      };

      const onChangeCustom = (e) => {
        const { value } = e.target;

        if (type === 'number') {
          const sanitizedValue = String(value).replace(/[+\-eE]/g, '');
          if (sanitizedValue !== String(value)) {
            form.setFieldValue(field.name, sanitizedValue);
            return;
          }

          if (typeof max === 'number' && Number(value) > max) {
            onMax();
            form.setFieldValue(field.name, max);
            return;
          }

          if (typeof min === 'number' && Number(value) < min) {
            onMin();
            form.setFieldValue(field.name, min);
            return;
          }

          if (value.length > 1 && value.charAt(0) === '0') {
            form.setFieldValue(field.name, value.slice(1));
            return;
          }
        }

        field.onChange(e);
        if (onChange) {
          onChange(e);
        }
      };

      if (type === 'number') {
        props.onIncrement = () => {
          if (!disabled) {
            const stepValue = Number(step) || 1;
            const nextValue = normalizeNumberByStep((Number(field.value) || 0) + stepValue, stepValue);
            if (typeof max === 'number' && nextValue > max) {
              onMax();
              form.setFieldValue(field.name, max);
            } else {
              form.setFieldValue(field.name, nextValue);
            }
          }
        };

        props.onDecrement = () => {
          if (!disabled) {
            const stepValue = Number(step) || 1;
            const nextValue = normalizeNumberByStep((Number(field.value) || 0) - stepValue, stepValue);
            if (typeof min === 'number' && nextValue < min) {
              onMin();
              form.setFieldValue(field.name, min);
            } else {
              form.setFieldValue(field.name, nextValue);
            }
          }
        };
      }

      return (
        <InputField
          {...field}
          {...props}
          label={label}
          min={min}
          max={max}
          step={type === 'number' ? step : undefined}
          onChange={onChangeCustom}
          onKeyDown={onKeyDown}
          onBeforeInput={onBeforeInput}
          onPaste={onPaste}
          onRemove={onRemove}
          onReset={onReset}
          type={type}
          placeholder={placeholder}
          readOnly={readOnly}
          disabled={disabled}
          error={!readOnly && touch && error}
        />
      );
    }}
  </Field>
);

export default Input;
